import { getJwtPayloadCore } from './analytics';
import localStorageKeys from './localStorageKeys';

export const setExpiresData = (token: string) => {
  const payload = getJwtPayloadCore(token);
  const { exp } = payload;
  localStorage.setItem(localStorageKeys.expirationDate, exp);
};
